import _Promise from "@babel/runtime-corejs3/core-js/promise";
import { useInstance } from 'intact-vue';
import { useState } from '../../hooks/useState';
import { methods as globalMethods } from './methods';
import { isFunction, isString } from 'intact-shared';
import { useReceive } from '../../hooks/useReceive';
export function useValidate(getErrorMessage, getErrorClassName, message, isDirty) {
  var instance = useInstance();
  var isValid = useState(true);
  var errorClassName = useState(undefined);
  var promise = null;
  useReceive(['value', 'rules'], validateIfDirty);
  function validateIfDirty() {
    if (isDirty.value) {
      validate();
    }
  }
  function validate() {
    var _instance$get = instance.get(),
      rules = _instance$get.rules,
      value = _instance$get.value;
    if (!rules) return true;
    cancel();
    var promises = [];
    var ruleNames = [];
    // check required rule firstly, detect whether it is empty or not
    var required = globalMethods.required(value, true);
    if (rules.required) {
      promises.push(required);
      ruleNames.push('required');
    }
    // if required rule passed, then check other rules
    if (required) {
      for (var key in rules) {
        var rule = rules[key];
        if (key === 'required' || rule === false) continue;
        var fn = void 0;
        if (isFunction(rule)) {
          fn = rule;
        } else {
          fn = globalMethods[key];
          /* istanbul ignore if */
          if (!fn) {
            console.warn("Can not find validate method: " + key);
            continue;
          }
        }
        promises.push(fn(value, rules[key]));
        ruleNames.push(key);
      }
    }
    return promise = _Promise.all(promises).then(function (results) {
      for (var index = 0; index < results.length; index++) {
        var result = results[index];
        if (result !== true) {
          var ruleName = ruleNames[index];
          return [false, result || getErrorMessage(ruleName), getErrorClassName(ruleName)];
        }
      }
      return [true, message.value, undefined];
    }, function (err) {
      var message;
      var className;
      if (isString(err)) {
        message = err;
      } else if (err) {
        message = err.message || getErrorMessage(err.name);
        className = err.className || getErrorClassName(err.name);
      }
      return [false, message, className];
    }).then(function (_ref) {
      var _isValid = _ref[0],
        _message = _ref[1],
        _className = _ref[2];
      // if cancelled, should return the last result
      if (promise.cancelled) return isValid.value;
      isDirty.set(true);
      errorClassName.set(_className);
      message.set(_message);
      isValid.set(_isValid);
      return _isValid;
    });
  }
  function cancel() {
    if (promise) {
      promise.cancelled = true;
    }
  }
  function reset() {
    isValid.set(true);
    errorClassName.set(undefined);
    cancel();
  }
  return {
    isValid: isValid,
    errorClassName: errorClassName,
    validate: validate,
    reset: reset
  };
}